import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';
import { copyFor } from '../../copy/copy';

const TitleComponent = props => (
    <Title>
        {props.useLocalRepresentative && props.localRepresentativeCallState > 1 ? (
            <Span>{copyFor('feedback', 'representatives', 'call')}</Span>
        ) : (
            <Span>
                {copyFor('feedback', 'singleRecipient', 'call', undefined, {
                    recipientName: props.recipientName
                })}
            </Span>
        )}
    </Title>
);

TitleComponent.propTypes = {
    recipientName: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    localRepresentativeCallState: PropTypes.number
};

const CallAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            thankYouTitle={props.thankYouTitle}
            useLocalRepresentative={props.useLocalRepresentative}
            titleComponent={
                <TitleComponent
                    recipientName={props.recipientName}
                    useLocalRepresentative={props.useLocalRepresentative}
                    localRepresentativeCallState={props.localRepresentativeCallState}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

CallAction.propTypes = {
    peopleCount: PropTypes.string.isRequired,
    recipientName: PropTypes.string.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    localRepresentativeCallState: PropTypes.number
};

export default connect(
    state => ({
        recipientName: state.call.successInfo.recipientName,
        peopleCount: state.call.completeCall.endUsersCount
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        thankYouText: state.call.successInfo.thankYouText || '',
        thankYouTitle: state.call.successInfo.thankYouTitle,
        useLocalRepresentative: state.call.successInfo.useLocalRepresentative,
        localRepresentativeCallState: state.call.successInfo.localRepresentativeState
    }),
    {}
)(CallAction);



// WEBPACK FOOTER //
// ./src/containers/Call/CallSuccess.jsx